import { useState } from "react";
import "./editor_options.css";
import { useItems } from "../../contexts/item_context";

const Btn = ({ onClick, title, label, icon, active, disabled = false }) => (
    <button
        className={`toolbar-btn${active ? " toolbar-btn--active" : ""}${disabled ? " toolbar-btn--disabled" : ""}`}
        onClick={onClick}
        title={title}
        type="button"
        disabled={disabled}
    >
        <span className="toolbar-btn__icon">{icon}</span>
        <span className="toolbar-btn__label">{label}</span>
    </button>
);

/* SVG icons */
const IconCopy = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect width="12" height="12" x="8" y="8" rx="2" ry="2" />
        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
    </svg>
);

const IconPaste = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z" />
        <path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2" />
    </svg>
);

const IconBeautify = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="4 7 4 4 20 4 20 7" />
        <line x1="9" y1="20" x2="15" y2="20" />
        <line x1="12" y1="4" x2="12" y2="20" />
    </svg>
);

const IconMinify = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 6h16M4 12h16M4 18h16" />
    </svg>
);

const IconCompare = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="8" height="18" rx="1" />
        <rect x="14" y="3" width="8" height="18" rx="1" />
        <line x1="11" y1="12" x2="13" y2="12" />
    </svg>
);

const IconModel = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z" />
        <polyline points="10 17 14 13 10 9" />
    </svg>
);

export default function EditorOptions({ compareMode, onToggleCompare, quicktypeMode, onToggleQuicktype }) {
    const { handleCopy, handlePaste, beautifyJSON, minifyJSON, getJsonValidation } = useItems();
    const [copiedFlash, setCopiedFlash] = useState(false);

    const { isValid } = getJsonValidation();

    const onCopy = async () => {
        await handleCopy();
        setCopiedFlash(true);
        setTimeout(() => setCopiedFlash(false), 1400);
    };

    return (
        <div className="toolbar">
            <span className="toolbar__title">EDITOR</span>
            <div className="toolbar__divider" />
            <div className="toolbar__actions">
                <Btn
                    onClick={onCopy}
                    title="Copy all (Ctrl+A, Ctrl+C)"
                    label={copiedFlash ? "Copied!" : "Copy"}
                    icon={<IconCopy />}
                    active={copiedFlash}
                />
                <Btn
                    onClick={handlePaste}
                    title="Paste from clipboard"
                    label="Paste"
                    icon={<IconPaste />}
                />
                <Btn
                    onClick={beautifyJSON}
                    title="Format JSON (Ctrl+B)"
                    label="Beautify"
                    icon={<IconBeautify />}
                />
                <Btn
                    onClick={minifyJSON}
                    title="Minify JSON"
                    label="Minify"
                    icon={<IconMinify />}
                />
                {isValid && (
                    <Btn
                        onClick={onToggleQuicktype}
                        title="Convert JSON to code"
                        label={quicktypeMode ? "Close Model" : "Model"}
                        icon={<IconModel />}
                        active={quicktypeMode}
                    />
                )}
            </div>
            <div className="toolbar__spacer" />
            <Btn
                onClick={onToggleCompare}
                title="Compare JSON side by side"
                label={compareMode ? "Close Compare" : "Compare"}
                icon={<IconCompare />}
                active={compareMode}
            />
        </div>
    );
}
